import React from 'react';
import { recognizeItems } from '../data/content';
export function Recognize() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-24" data-id="element-147" data-mp="30wohs94qq3vn">
      <div className="mx-auto max-w-4xl" data-id="element-148" data-mp="30zaz30hfnxr2">
        <div className="text-center" data-id="element-149" data-mp="2w5yfx5viwj5p">
          <h2 className="font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-150" data-mp="2w4wxuhg3aweh">
            <span aria-hidden="true" data-id="element-151" data-mp="2r5kfa8w94bhp">👉 </span>Do You Recognize Yourself in
            These Situations?
          </h2>
          <p className="mt-3 text-sm text-ink/55" data-id="element-152" data-mp="2i6yo5pcpro5b">
            If you said yes to any of these — this pack is for you.
          </p>
        </div>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-153" data-mp="2d8f3rtdrqkf2">
          {recognizeItems.map(item => <li key={item.text} className="flex items-start gap-3 rounded-xl bg-white px-4 py-4" data-id="element-154" data-mp="28adgew9b7yxs">
              <span className="text-base leading-none" aria-hidden="true" data-id="element-155" data-mp="6hfmex3sr0b9">
                {item.emoji}
              </span>
              <span className="text-xs font-medium leading-snug text-ink/80" data-id="element-156" data-mp="3jk0tuwjpib7w">
                {item.text}
              </span>
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display text-lg font-bold italic text-brand sm:text-xl" data-id="element-157" data-mp="39n5wwi330ivq">
          And you deserve so much more than that →
        </p>
      </div>
    </section>;
}